import { createApp } from 'vue';
import App from './App.vue'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css';
import './styles.css';

const app = createApp(App);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false, // Disable automatic dark mode
            cssLayer: false
        }
    }
});
app.mount('#app')
